export default __webpack_public_path__ + "static/media/truck.b3671afb.svg";